module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normalb"
  }, [_c('i', [_vm._v("I am accustoming myself to the idea of regarding every sexual act as a process in which four persons are involved. We shall have a lot to discuss about that")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("S. FREUD: "), _c('i', [_vm._v("Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "normalb sgc-1"
  }, [_vm._v("There are two positions available to us – either crime which renders us happy, or the noose, which prevents us from being unhappy. I ask whether there can be any hesitation, lovely Thérèse, and where will your little mind find an argument able to combat that one?")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("D. A. F. DE SADE: "), _c('i', [_vm._v("Justine")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-939055f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03_series.vue
// module id = 78
// module chunks = 0